import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function OfferSection() {
  const includes = ['Identificación de la raíz que hoy está afectando tu proceso', 'Lectura clara de tu patrón dominante', 'Intervención personalizada', 'Plan de acción inicial', 'Espacio confidencial y sin juicio', 'Grabación opcional', 'Acceso a comunidad y seguimiento'];
  return <section className="py-14 px-4 bg-navy-950 text-white relative overflow-hidden" data-id="element-148">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-149" />

      <div className="max-w-3xl mx-auto relative z-10 space-y-14" data-id="element-150">
        {/* Lo que recibes */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-12" data-id="element-152">
            Lo que recibes
          </h2>

          <div className="bg-navy-900/40 border border-navy-800 rounded-3xl p-8 md:p-12 backdrop-blur-sm" data-id="element-153">
            <ul className="space-y-6" data-id="element-154">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-155">
                  <div className="mt-1 w-5 h-5 rounded-full bg-gold-500/20 flex items-center justify-center shrink-0" data-id="element-156">
                    <Check className="w-3 h-3 text-gold-400" data-id="element-157" />
                  </div>
                  <span className="text-lg text-navy-100" data-id="element-158">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mt-16 text-center space-y-4 font-serif text-2xl md:text-3xl text-gold-400 italic" data-id="element-159">
            <p data-id="element-160">Una conversación privada.</p>
            <p data-id="element-161">Una lectura precisa.</p>
            <p data-id="element-162">Una dirección concreta.</p>
          </div>

          <div className="mt-12 text-center" data-id="element-163">
            <a href="#cta-final" className="inline-flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-navy-950 px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_-10px_rgba(211,154,34,0.3)]" data-id="element-164">
              QUIERO RESERVAR MI ESPACIO
              <ArrowRight className="w-5 h-5" data-id="element-165" />
            </a>
          </div>
        </motion.div>

        {/* Para quién es / no es */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="grid md:grid-cols-2 gap-8" data-id="element-166">
          <div className="bg-navy-900/30 border border-navy-800 rounded-3xl p-8" data-id="element-167">
            <h3 className="text-xl font-bold tracking-widest uppercase text-white mb-6" data-id="element-168">
              Para quién es
            </h3>
            <ul className="space-y-4 text-navy-200" data-id="element-169">
              <li data-id="element-170">
                Para personas que perciben que su bloqueo no es superficial.
              </li>
              <li data-id="element-171">
                Que ya probaron avanzar con voluntad, contenido o estructura… y
                saben que aún hay algo más profundo interfiriendo.
              </li>
              <li data-id="element-172">
                Que valoran la verdad, la dirección y el trabajo interior serio.
              </li>
            </ul>
          </div>

          <div className="bg-navy-900/30 border border-navy-800 rounded-3xl p-8" data-id="element-173">
            <h3 className="text-xl font-bold tracking-widest uppercase text-navy-400 mb-6" data-id="element-174">
              Para quién no es
            </h3>
            <ul className="space-y-4 text-navy-400" data-id="element-175">
              <li data-id="element-176">
                Para quien busca una solución inmediata sin responsabilidad
                personal.
              </li>
              <li data-id="element-177">Para quien no está dispuesto a mirarse con honestidad.</li>
              <li data-id="element-178">
                Para quien necesita terapia clínica o asesoría financiera
                profesional.
              </li>
            </ul>
          </div>
        </motion.div>

        {/* Garantía & CTA Final */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="text-center pt-12 border-t border-navy-800" data-id="element-179">
          <div className="mb-16 max-w-xl mx-auto" data-id="element-180">
            <h3 className="text-sm font-bold tracking-[0.2em] uppercase text-gold-400 mb-6" data-id="element-181">
              Garantía
            </h3>
            <p className="text-lg text-navy-200 leading-relaxed" data-id="element-182">
              Si al finalizar la sesión sientes que no recibiste claridad,
              dirección o valor real para tu proceso:
              <br data-id="element-183" />
              <span className="text-white font-bold mt-2 block" data-id="element-184">no pagas.</span>
            </p>
          </div>

          <div className="mb-8" data-id="element-185">
            <h3 className="text-sm font-bold tracking-[0.2em] uppercase text-navy-400 mb-4" data-id="element-186">
              Inversión
            </h3>
            <div className="flex flex-col items-center gap-2" data-id="element-187">
              <p className="text-5xl md:text-6xl font-serif font-bold text-white" data-id="element-188">
                $33 <span className="text-2xl text-gold-400" data-id="element-189">USD</span>
              </p>
              <p className="text-navy-400 line-through mt-2" data-id="element-190">$397 USD</p>
              <p className="text-sm text-gold-400 uppercase tracking-widest font-bold mt-4" data-id="element-191">
                Lanzamiento · acceso limitado
              </p>
            </div>
          </div>

          <a id="cta-final" href="https://www.inerciacero.com/cart/43776212041831:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
          value: 33,
          currency: 'USD',
          content_name: 'Charla personalizada — El Triángulo Roto'
        })} className="group relative inline-flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-navy-950 px-10 py-5 rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_-10px_rgba(211,154,34,0.4)] w-full md:w-auto scroll-mt-[50vh]" data-id="element-192">
            QUIERO RESERVAR MI ESPACIO
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-193" />
          </a>
        </motion.div>
      </div>
    </section>;
}